var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component dropdown-indicator"},[_c('div',{staticClass:"indicator-content"},[_vm._t("default")],2),(_vm.hasIcon)?_c('Icon',{staticClass:"indicator-icon",attrs:{"name":_vm.iconName,"size":_vm.iconSize}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }